export default "__VITE_ASSET__LLoCLgcy__"